/* BELNU DC redesign — shared behavior */
(function () {
  'use strict';

  /* ---- Carousel progress bars ---- */
  function wireCarousel(car) {
    var bar = document.querySelector('.bdc-bar__fill[data-bar-for="' + car.dataset.bdcCar + '"]');
    if (!bar) return;
    var fillPct = car.classList.contains('bdc-hero__track') ? 33.33 : 25;
    var travel = (100 / fillPct - 1) * 100; /* translateX % of own width */
    function update() {
      var max = car.scrollWidth - car.clientWidth;
      var pos = max > 0 ? car.scrollLeft / max : 0;
      bar.style.transform = 'translateX(' + (pos * travel).toFixed(1) + '%)';
    }
    car.addEventListener('scroll', update, { passive: true });
    update();
  }
  document.querySelectorAll('[data-bdc-car]').forEach(wireCarousel);

  /* ---- Hero card crossfade per slide ---- */
  document.querySelectorAll('.bdc-hero').forEach(function (hero) {
    var track = hero.querySelector('.bdc-hero__track');
    var cards = hero.querySelectorAll('.bdc-hero__card');
    if (!track || cards.length < 2) return;
    var current = 0, fadeTo, fadeT;
    cards.forEach(function (c, i) { if (i !== 0) c.hidden = true; });
    track.addEventListener('scroll', function () {
      var max = track.scrollWidth - track.clientWidth;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      var target = Math.max(0, Math.min(cards.length - 1, Math.round(pos * (cards.length - 1))));
      if (target === current || fadeTo === target) return;
      fadeTo = target;
      clearTimeout(fadeT);
      cards[current].classList.add('is-fading');
      fadeT = setTimeout(function () {
        cards[current].hidden = true;
        cards[current].classList.remove('is-fading');
        current = target; fadeTo = undefined;
        cards[current].hidden = false;
        cards[current].classList.add('is-fading');
        requestAnimationFrame(function () { requestAnimationFrame(function () { cards[current].classList.remove('is-fading'); }); });
      }, 220);
    }, { passive: true });
  });

  /* ---- Draggable progress bars (hero) ---- */
  document.querySelectorAll('[data-bdc-bar-drag]').forEach(function (el) {
    el.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      var car = document.querySelector('[data-bdc-car="' + el.dataset.bdcBarDrag + '"]');
      if (!car) return;
      var rect = el.getBoundingClientRect();
      function setFrom(clientX) {
        var f = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
        car.scrollLeft = f * (car.scrollWidth - car.clientWidth);
      }
      setFrom(e.clientX);
      function mv(ev) { setFrom(ev.clientX); }
      function up() {
        window.removeEventListener('pointermove', mv);
        window.removeEventListener('pointerup', up);
      }
      window.addEventListener('pointermove', mv);
      window.addEventListener('pointerup', up);
    });
  });

  /* ---- Quick add to cart ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bdc-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var id = parseInt(btn.getAttribute('data-bdc-add'), 10);
    if (!id) return;
    btn.disabled = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['cart-drawer', 'main-cart'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (data) {
      /* Reuse the site-wide add-to-cart event: opens the cart drawer and
         triggers the existing 50ml -> mini auto-addition logic. */
      if (typeof CustomEvent === 'function') {
        window.dispatchEvent(new CustomEvent('belnuQuickAdd', { detail: { response: data } }));
      }
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) {
      document.querySelectorAll('[data-bdc-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }).catch(function (err) {
      console.error('BDC quick add error:', err);
    }).finally(function () { btn.disabled = false; });
  }, true);

  /* ---- Nav wordmark ⇄ monogram crossfade at footer ---- */
  var nav = document.querySelector('.bdc-nav');
  if (nav) {
    var onScroll = function () {
      var ft = document.querySelector('.bdc-foot') || document.querySelector('footer');
      var atBottom;
      if (ft) {
        var r = ft.getBoundingClientRect();
        atBottom = window.innerHeight >= r.top + r.height / 2;
      } else {
        atBottom = window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 120;
      }
      nav.classList.toggle('bdc-nav--mark', atBottom);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Press module ---- */
  document.querySelectorAll('[data-bdc-press]').forEach(function (root) {
    var quotes = JSON.parse(root.querySelector('[data-bdc-press-data]').textContent);
    var n = quotes.length;
    if (!n) return;
    var quoteEl = root.querySelector('.bdc-press__quote span');
    var belt = root.querySelector('.bdc-press__belt');
    var logos = Array.prototype.slice.call(root.querySelectorAll('.bdc-press__logo'));
    var idx = 0, busy = false, timer = null;
    var CELL = 280;
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function shift(animate) {
      belt.style.transition = animate && !reduced ? '' : 'none';
      belt.style.transform = 'translateX(' + (-((n + idx) * CELL + CELL / 2)) + 'px)';
      if (!animate) { void belt.offsetWidth; belt.style.transition = ''; }
    }
    function paint() {
      var active = ((idx % n) + n) % n;
      logos.forEach(function (el, i) { el.classList.toggle('is-active', i % n === active); });
      quoteEl.textContent = quotes[active];
    }
    function step(delta) {
      if (busy) return;
      var advance = function () {
        idx += delta;
        shift(true);
        paint();
        quoteEl.classList.remove('is-out');
        if (idx >= n || idx < 0) {
          setTimeout(function () { idx = ((idx % n) + n) % n; shift(false); }, 950);
        }
      };
      if (reduced) { advance(); return; }
      busy = true;
      quoteEl.classList.add('is-out');
      setTimeout(function () { advance(); busy = false; }, 250);
    }
    function start() { if (!timer) timer = setInterval(function () { step(-1); }, 6500); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function manual(delta) { stop(); start(); step(delta); }

    logos.forEach(function (el, i) {
      el.addEventListener('click', function () {
        var active = ((idx % n) + n) % n;
        var t = i % n;
        if (t === active) return;
        var d = t - active;
        if (d > n / 2) d -= n;
        if (d < -n / 2) d += n;
        manual(d);
      });
    });
    var px = null;
    var strip = root.querySelector('.bdc-press__strip');
    strip.addEventListener('pointerdown', function (e) { px = e.clientX; });
    strip.addEventListener('pointerup', function (e) {
      if (px == null) return;
      var dx = e.clientX - px;
      px = null;
      if (Math.abs(dx) > 30) manual(dx < 0 ? 1 : -1);
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    shift(false);
    paint();
    start();
  });
})();
